const setRegYear = payload => {
  return {
    type: "regyear",
    payload
  };
};

export default setRegYear;
